<template>
  <div>
    <div v-if="parameters.version === 'v2'">
      <div :data-sitekey="parameters.sitekey" class="g-recaptcha"></div>
      <input :name="parameters.versionFieldName" :value="parameters.version" type="hidden" />
    </div>
    <div v-if="parameters.version === 'v3'">
      <input
        ref="formVersion"
        :name="parameters.versionFieldName"
        :value="parameters.version"
        type="hidden"
      />
      <input :name="parameters.actionFieldName" :value="parameters.action" type="hidden" />
      <input :name="parameters.responseFieldName" :value="responseToken" type="hidden" />
    </div>
  </div>
</template>

<script>
export default {
  name: "FormRecaptcha",
  props: {
    parameters: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      responseToken: "",
    };
  },
  mounted() {
    if (this.parameters.version === "v3") {
      this.initV3();
    }
  },
  methods: {
    initV3() {
      window.withRecaptchaLoaded(() => {
        this.$refs.formVersion.form.addEventListener("submit", async e => {
          e.preventDefault();
          try {
            this.responseToken = await window.grecaptcha.execute(this.parameters.apiKey, {
              action: this.parameters.action,
            });
          } catch {
            throw new Error("reCaptcha failed!");
          }
          this.$nextTick(() => {
            e.target.submit();
          });
        });
      });
    },
  },
};
</script>
